import React, { Suspense, lazy } from "react";
import { createFileRoute, useParams } from "@tanstack/react-router";
import SiteHeader from "@/components/common/SiteHeader";
import { useStaffLL88SubmissionQuery } from "@/queries/queries";

// Wave-17 Item 1.1 — Staff LL88 submission page lazy-loaded.
const LL88Page = lazy(() => import("@/pages/Staff/LL88/Submission/Page"));

const CalendarYearPill: React.FC<{ year: number | undefined }> = ({ year }) =>
  typeof year === "number" ? (
    <span
      aria-label={`Calendar year ${year}`}
      className="inline-flex items-center rounded-md border border-blue-600 bg-blue-50 text-blue-800 px-3 py-1 text-sm font-semibold"
    >
      {`CY${year}`}
    </span>
  ) : null;

const LL88Route = () => {
  const { submissionId } = useParams({ from: "/staff/ll88/$submissionId" });
  const { data } = useStaffLL88SubmissionQuery(submissionId);
  const year: number | undefined =
    data?.submission?.calendarYear ?? data?.calendarYear;

  return (
    <div className="flex flex-col w-full min-h-full">
      <SiteHeader header="LL88" />
      <div className="flex items-center gap-3 px-10 pt-4">
        <CalendarYearPill year={year} />
      </div>
      <Suspense fallback={null}>
        <LL88Page />
      </Suspense>
    </div>
  );
};

export const Route = createFileRoute("/staff/ll88/$submissionId")({
  component: LL88Route,
});
